var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M5 12.7109L15.8 2.31863L15.8 23.1032L5 12.7109Z","fill":"#F1EDE5"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"24","height":"24","fill":"white","transform":"translate(0 0.710938)"})))]);
}

LeftArrow.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
